module.exports = __webpack_public_path__ + "img/shoot_00005.e5bde45b.png";